import React from 'react';
import './ForgotPassword.scss';
import { TwButton, TwButtonType } from '../../components/TwButtons/TwButtons';
import { TwTitle, TwTitleColor, TwTitleType } from '../../components/TwTitles/TwTitles';
import { ReactComponent as TruckbaseLogo } from '../../assets/truckbase-logo.svg';
import { ReactComponent as TbLogo } from '../../assets/tb-logo.svg';
import TwField, { TwInputTypes } from '../../components/TwFields/TwFields';
import { Formik, Form } from 'formik';
import AuthService from '../../providers/Auth/Auth.service';
import { Link, useNavigate } from 'react-router-dom';

interface ForgotPasswordFormValues {
  email: string;
}

const ForgotPassword: React.FC = (): JSX.Element => {
  const navigate = useNavigate();

  const initialValues: ForgotPasswordFormValues = {
    email: ''
  };

  const forgotPasswordSubmit = (values: { email: string }): void => {
    AuthService.forgotPassword(values.email)
      .then(() => {
        navigate('/reset-password');
      })
      .catch((error) => alert(error.message));
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={(values: ForgotPasswordFormValues): void => {
          forgotPasswordSubmit(values);
        }}
      >
        {({ values, handleChange, handleSubmit }): JSX.Element => (
          <Form>
            <div className="forgot-password__wrapper tid-forgot-password__wrapper">
              <div className="forgot-password__form-section">
                <div className="forgot-password__form-logo">
                  <TbLogo />
                </div>

                <div className="forgot-password__title">
                  <TwTitle type={TwTitleType.secondary} text="Forgot password?" />
                </div>

                <div className="forgot-password__inputs-container">
                  <span className="forgot-password__instructions">
                    {"Enter your email address & we'll send you a link to reset your password."}
                  </span>
                  <div className="tid-forgot-password__email">
                    <TwField
                      id="email"
                      name="email"
                      value={values.email}
                      label="Email"
                      inputType={TwInputTypes.text}
                      disabled={false}
                      onInputChange={handleChange}
                      error={false}
                    />
                  </div>

                  <div className="forgot-password__action-container">
                    <div className="forgot-password__submit-button">
                      <TwButton
                        label="Send"
                        disabled={false}
                        fullwidth
                        type={TwButtonType.primary}
                        action={(): void => {
                          if (values.email) {
                            handleSubmit();
                          }
                        }}
                      />
                    </div>

                    <span className="forgot-password__back">
                      <Link to="/signin">Back to sign in</Link>
                    </span>
                  </div>
                </div>
              </div>

              <div className="forgot-password__photo-section">
                <div className="forgot-password__logo-container">
                  <TruckbaseLogo className="forgot-password__logo" />
                </div>
                <TwTitle type={TwTitleType.primary} text="More trucking." />
                <TwTitle
                  type={TwTitleType.primary}
                  color={TwTitleColor.red}
                  text="Less paperwork."
                />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ForgotPassword;
